<style lang="scss">
.home-slide {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;

  &__loading {
    position: absolute;
    z-index: 1;
    height: 150px;
    width: 150px;
  }
}
</style>

<template>
  <div class="home-slide">
    <v-spinner
      class="home-slide__loading"
      :show="loading"
    />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VHomeSlide',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
